/* Thème Shestia, sh-categories-grid (ACCUEIL-1, 04/10/2026) : cascade des tuiles, rangée par rangée. Écrit de zéro.
   Relevé sur la référence, /pages/lookbook à 390 x 844 en contexte tactile, à vitesse de main (défilement de 100 px
   toutes les 100 ms et molette), opacité effective de chaque tuile lue à chaque image
   (outputs/shestia-theme-2026-10-02/accueil-1/sonde_tuiles_doigt.py) :
   - quand une rangée passe la ligne de déclenchement commune, TOUTES ses tuiles montent en fondu l'une après l'autre,
     à 100 ms d'écart, dans l'ordre : 6 tuiles pour la première rangée, 4 pour la seconde (la tuile texte « EDIT 01 » en
     troisième), y compris celles que la rangée cache à droite de l'écran (montée de 34 px, 458 ms entre 3 % et 99 %) ;
   - animations réduites : toutes les tuiles sont posées d'emblée.
   L'observateur commun (Shestia.reveal) ne voit que les tuiles à l'écran : dès que l'une part, celles qu'il n'a pas vues
   suivent ici, à la suite. Le relevé du 03/10 (« tuiles photo posées dès le chargement ») lisait l'opacité du mauvais
   élément : il était faux, le juge l'a vu au film. À l'ordinateur toutes les tuiles d'une rangée sont à l'écran ensemble :
   rien ne change. */
(function () {
  'use strict';
  if (window.__shCgridCascade) return;
  window.__shCgridCascade = true;

  function cascadeEntiere(rangee) {
    if (!rangee || rangee._shCascade) return;
    rangee._shCascade = true;
    var lancees = 0, prevu = false;
    rangee.addEventListener('sh:reveal', function (e) {
      var tuile = e.target;
      if (!tuile || tuile.parentElement !== rangee) return;
      tuile._shParti = true;                          // Shestia.reveal.play émet l'événement dès qu'un départ est lancé
      lancees += 1;
      if (prevu) return;
      prevu = true;
      setTimeout(function () {                        // après la fin du lot de l'observateur
        prevu = false;
        var S = window.Shestia;
        if (!S || !S.reveal || typeof S.reveal.play !== 'function') return;
        var pas = parseFloat(rangee.getAttribute('data-sh-reveal-stagger')) || 100;
        var rang = lancees;
        Array.prototype.slice.call(rangee.children).forEach(function (suivante) {
          if (suivante._shParti || suivante.classList.contains('is-revealed')) return;
          S.reveal.play(suivante, rang * pas);
          rang += 1;
        });
      }, 0);
    });
  }

  function lancer() {
    Array.prototype.slice.call(document.querySelectorAll('.sh-cgrid__track[data-sh-reveal="stagger"]')).forEach(cascadeEntiere);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', lancer, { once: true });
  else lancer();
})();
